import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Form, Modal } from "react-bootstrap";
import MainHeader from "../Pages/Header/MainHeader";
import FooterStyle from '../Pages/Footer/Footer';
import VoteModal from "../Pages/ComponentPage/VoteModal";
import PostModal from "../Pages/ComponentPage/PostPopup"; // Import the PostModal component
import API from '../Api/Api';
import { IMAGE_PATHS, DOMAIN_URL, formatDate } from '../Functions/Constant';
import { Link } from "react-router-dom";
import Loader from "../Components/Loader";
import ConfirmationPopup from '../Components/ConfirmationPopup'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import WelcomeModal from "../Pages/ComponentPage/WelcomePopup";
import WebsiteStep from "../Pages/ComponentPage/WebsiteStep";
import StarRating from '../Components/StarRating'
import InfoTooltipRating from '../Components/InfoTooltipRating'

const Feed = () => {
    const currentDate = new Date();
    const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth() + 1);
    const [postText, setPostText] = useState("");
    const [postComments, setPostComments] = useState({});
    const [commentsToShow, setCommentsToShow] = useState(2);
    const [focusedReply, setFocusedReply] = useState(null);
    const [menuOpen, setMenuOpen] = useState(null);
    const [selectedVotes, setSelectedVotes] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [posts, setPosts] = useState([]);
    const [visibleCount, setVisibleCount] = useState(5);
    const [error, setError] = useState("");
    const loaderRef = useRef(null);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [popupAction, setPopupAction] = useState(null);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false); // Open by default
    const [limit] = useState(10); // Fixed limit as per your API
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [totalStreaks, setTotalStreaks] = useState(0);

    const handleCloseWelcome = () => setShowWelcomeModal(false);
    const [ratings, setRatings] = useState({
        overall_rating: 0,
        total_reviews: null,
        is_ai_summary: 0,
        excellent: 0,
        very_good: 0,
        average: 0,
        poor: 0,
        terrible: 0
    });
    const [mainRating, setMainRating] = useState({
        core: 0,
        creativity: 0,
        personal: 0,
        technical: 0,
        interpersonal: 0
    });
    const fetchData = async () => {
        try {
            const endpoint = `/reviews/overall_rating`;
            const res = await API.get(endpoint);

            if (res.overall_rating) {
                setRatings({
                    overall_rating: res.overall_rating.overall_rating || 0,
                    total_reviews: res.overall_rating.total_reviews || 0,
                    is_ai_summary: res.overall_rating.is_ai_summary || 0,
                    excellent: res.overall_rating.excellent || 0,
                    very_good: res.overall_rating.very_good || 0,
                    average: res.overall_rating.average || 0,
                    poor: res.overall_rating.poor || 0,
                    terrible: res.overall_rating.terrible || 0

                });
            }
            if (res.category_ratings) {
                setMainRating({
                    core: res.category_ratings.core || 0,
                    creativity: res.category_ratings.creativity || 0,
                    personal: res.category_ratings.personal || 0,
                    technical: res.category_ratings.technical || 0,
                    interpersonal: res.category_ratings.interpersonal || 0
                })

            }


            console.log(res)
        } catch (error) {
            console.error(error);
        } finally {
        }
    };


    const handlePostModal = async ({ file, fileType, text, tag, privacy, originalFile }) => {
        if (!text.trim()) return;
        setSelectedMonth("March");
        try {
            // Prepare request payload
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().toLocaleString("default", { month: "long" });
            const formData = new FormData();
            const token = localStorage.getItem('jwt_token_jobcritic');
            formData.append("visibility", privacy);
            formData.append("content", text);
            formData.append("tag", tag);
            formData.append("month", currentMonth); // Convert month name to number (1-12)
            formData.append("year", currentYear);

            let mediaObj = null;
            let filename = null;

            // Handle media/attachments (if a file is provided)
            if (originalFile) {
                originalFile.forEach((media) => {
                    formData.append('attachments', media.file); // Append each file to FormData
                });
                //formData.append("attachments", originalFile); // Append file
                filename = originalFile.name; // Extract filename from file object

                // Construct the media object with filename as URL
                mediaObj = {
                    type: fileType || "image", // Default to image if type is missing
                    url: file // Use filename instead of file URL
                };

                // Append media as JSON string
                formData.append("media", JSON.stringify(mediaObj));
            }

            // Send API request
            const result = await API.post(
                '/streaks/add-streak',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );
            getMonthlyStreaks(selectedMonth);
            //            const userDataString = localStorage.getItem("userData");
            //            const userData = JSON.parse(userDataString);
            //            // Create a new post object for UI update
            //            const newPost = {
            //                id: result.streak_id,
            //                user: userData?.name, // Replace with dynamic user data
            //                location: "",
            //                time: "Just now",
            //                content: text,
            //                views: "0",
            //                upvotes: 0,
            //                downvotes: 0,
            //                comments: 0,
            //                reposts: 0,
            //                upvoted: false,
            //                downvoted: false,
            //                imageUrl: file || null, // Use filename for UI
            //                year: currentYear,
            //                month: currentMonth,
            //            };
            //
            //            // Ensure current year & month are selected
            //            setSelectedYear(currentYear);
            //            setSelectedMonth(currentMonth);
            //
            //            // Update UI state with the new post at the top
            //            setPosts((prevPosts) => [newPost, ...prevPosts]);

            // Reset input fields & close modal
            setPostText("");
            setCurrentPage(1); // Reset to first page
            setShowModal(false);
        } catch (error) {
            console.error("Upload failed:", error);
        }

    };

    // useEffect(() => {
    //     console.log("Updated posts:", posts);
    // }, [posts]);
    const menuRefs = useRef({}); // Store refs for each menu dynamically


    const toggleCommentBox = async (id) => {
        const token = localStorage.getItem('jwt_token_jobcritic');
        try {
            const result = await API.post('/streaks/view-comments',
                {
                    streak_id: id
                }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Token from login
                },
            });


            if (result && result.comments) {
                setPostComments(prevComments => ({
                    ...prevComments,
                    [id]: {
                        showCommentBox: !prevComments[id]?.showCommentBox, // Toggle visibility
                        comments: result.comments // Update comments from API
                    }
                }));
            }
        } catch (error) {
            console.error("Upload failed:", error);
            //            setImageError("Failed to upload image. Please try again.");
        }
    };

    const handleCommentChange = (postId, text) => {
        setPostComments({
            ...postComments,
            [postId]: { ...postComments[postId], commentText: text }
        });
    };

    const handlePostComment = async (postId) => {
        //        const userDataString = localStorage.getItem("userData");
        //        const userData = JSON.parse(userDataString);
        // Access the profile_image
        //        const profileImage = userData.profile_image;
        if (!postComments[postId]?.commentText?.trim()) return;
        const token = localStorage.getItem('jwt_token_jobcritic');
        try {
            const result = await API.post('/streaks/add-comment',
                {
                    comment: postComments[postId]?.commentText?.trim(),  // Ensure these values are set
                    streak_id: postId
                }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Token from login
                },
            });
            const newComment = {
                id: result.comment._id,
                text: postComments[postId].commentText,
                username: userData?.name,
                profile_title: userData?.profile_title,
                location: userData?.city_name,
                user_id: userData?.user_id,
                profileImg: userData?.profile_image_without_domain,
                time: new Date().toISOString(),
                upvotes: 0,
                replies: []
            };

            setPostComments((prevComments) => ({
                ...prevComments,
                [postId]: {
                    showCommentBox: true,
                    commentText: "",
                    comments: [newComment, ...(prevComments[postId]?.comments || [])], // Prepend new comment
                }
            }));


        } catch (error) {
            console.error("Upload failed:", error);
            //            setImageError("Failed to upload image. Please try again.");
        }

    };

    const deleteComment = async (dataArr) => {
        const payload = {
            comment_id: dataArr.comment_id,
            streak_id: dataArr.streak_id
        };
        //console.log(review_id, comment_id);
        const response = await API.post(`/streaks/deleteComment`, payload);
        //window.location.reload();
        setShowPopup(false);
    };
    const reportComment = async (dataArr) => {
        const payload = {
            comment_id: dataArr.comment_id,
            streak_id: dataArr.streak_id
        };
        //console.log(review_id, comment_id);
        const response = await API.post(`/streaks/reportComment`, payload);
        //window.location.reload();
        setShowPopup(false);
    };
    const deleteReply = async (dataArr) => {
        const payload = {
            replyId: dataArr.replyId,
            streakId: dataArr.streakId,
            commentId: dataArr.commentId
        };
        //console.log(review_id, comment_id);
        const response = await API.post(`/streaks/deleteReply`, payload);
        //window.location.reload();
        setShowPopup(false);
    };

    const reportReply = async (dataArr) => {
        const payload = {
            replyId: dataArr.replyId,
            streakId: dataArr.streakId,
            commentId: dataArr.commentId
        };
        //console.log(review_id, comment_id);
        const response = await API.post(`/streaks/reportReply`, payload);
        //window.location.reload();
        setShowPopup(false);
    };
    const deletePost = async (dataArr) => {
        const payload = {
            streakId: dataArr.streakId
        };
        //console.log(review_id, comment_id);
        const response = await API.post(`/streaks/deletePost`, payload);
        //window.location.reload();
        setShowPopup(false);
    };

    const reportPost = async (dataArr) => {
        const payload = {
            streakId: dataArr.streakId
        };
        //console.log(review_id, comment_id);
        const response = await API.post(`/streaks/reportPost`, payload);
        //window.location.reload();
        setShowPopup(false);
    };
    const toggleReplyBox = (postId, commentId) => {
        console.log("comments", postComments);
        setPostComments({
            ...postComments,
            [postId]: {
                ...postComments[postId],
                comments: postComments[postId]?.comments?.map(comment =>
                    comment.id === commentId ? { ...comment, showReplyBox: !comment.showReplyBox } : comment
                )
            }
        });
    };

    const handleReplyChange = (postId, commentId, text) => {
        setPostComments({
            ...postComments,
            [postId]: {
                ...postComments[postId],
                comments: postComments[postId]?.comments?.map(comment =>
                    comment.id === commentId ? { ...comment, replyText: text } : comment
                )
            }
        });
    };

    const handleReplySubmit = async (postId, commentId, text) => {
        console.log("Pos", postId);
        console.log("commentId", commentId);
        console.log("userData", userData);
        if (!text) return;
        const token = localStorage.getItem('jwt_token_jobcritic');
        //        const userDataString = localStorage.getItem("userData");
        //        const userData = JSON.parse(userDataString);
        // Access the profile_image
        //        const profileImage = userData.profile_image;
        try {
            const result = await API.post('/streaks/add-reply',
                {
                    comment_id: commentId,  // Ensure these values are set
                    reply: text
                }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Token from login
                },
            });
            setPostComments((prevComments) => {
                const updatedComments = prevComments[postId]?.comments?.map((comment) => {
                    console.log(result.updatedComment.replies[0]._id);
                    if (comment.id === commentId) {
                        let newReply = {
                            id: result.updatedComment.replies[0]._id,
                            text: text || "This is a dummy reply!",
                            username: "You",
                            user_id: userData?.user_id,
                            location: userData?.city_name,
                            profile_title: userData?.profile_title,
                            profileImg: userData?.profile_image_without_domain,
                            time: new Date().toISOString(),
                        };

                        return {
                            ...comment,
                            replies: [...comment.replies, newReply], // Add new reply to replies array
                            replyText: "", // Clear input field
                            showReplyBox: false
                        };
                    }
                    return comment;
                });

                return {
                    ...prevComments,
                    [postId]: {
                        ...prevComments[postId],
                        comments: updatedComments
                    }
                };
            });


        } catch (error) {
            console.error("Upload failed:", error);
            //            setImageError("Failed to upload image. Please try again.");
        }

    };


    // const getMonthlyStreaks = async (month) => {
    //     setPosts([]);
    //     const token = localStorage.getItem('jwt_token_jobcritic');
    //     setSelectedMonth(month);
    //     setLoading(true); // Start loading
    //     try {
    //         const result = await API.post('/streaks/view-streaks',
    //             {
    //                 month: month,  // Ensure these values are set
    //                 year: selectedYear
    //             }, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //                 'Authorization': `Bearer ${token}`, // Token from login
    //             },
    //         });


    //         if (result && result.streaks) {
    //             setPosts(result.streaks.slice(0, visibleCount + 5));
    //             const initialSlides = result.streaks.reduce((acc, post) => {
    //                 acc[post._id] = 0; // Start at the first slide for each post
    //                 return acc;
    //             }, {});
    //             setCurrentSlide(initialSlides);
    //         } else {
    //             setPosts([]);
    //         }
    //         console.log("Before adding new post, posts.length:", posts.length);

    //         console.log(posts);
    //     } catch (error) {
    //         console.error("Upload failed:", error);
    //         //            setImageError("Failed to upload image. Please try again.");
    //     }
    //     finally {
    //         setLoading(false); // Stop loading regardless of success or failure
    //     }
    // };
    const getMonthlyStreaks = async (month, page = 1) => {
        const token = localStorage.getItem('jwt_token_jobcritic');
        setSelectedMonth(month);
        setLoading(page === 1); // Full loading only on first page
        setIsLoadingMore(page > 1); // Loading more for subsequent pages
        try {
            const result = await API.post('/streaks/view-streaks', {
                month: month,
                year: selectedYear,
                page: page,
                limit: limit, // 10 as defined in state
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (result && result.streaks) {
                const mappedPosts = result.streaks.map(post => ({
                    ...post,
                    upvoted: post.vote_type === 1,
                    downvoted: post.vote_type === 2,
                    upvotes: parseInt(post.upvotes) || 0,
                    downvotes: parseInt(post.downvotes) || 0
                }));

                // Append new posts to existing ones, no reset
                setPosts(prev => page === 1 ? mappedPosts : [...prev, ...mappedPosts]);

                setCurrentPage(result.pagination.currentPage);
                setTotalPages(result.pagination.totalPages);
                setTotalStreaks(result.pagination.totalStreaks);
                const initialSlides = mappedPosts.reduce((acc, post) => {
                    acc[post._id] = 0;
                    return acc;
                }, {});
                setCurrentSlide(prev => ({ ...prev, ...initialSlides }));
            }
        } catch (error) {
            console.error("Failed to fetch streaks:", error);
        } finally {
            setLoading(false);
            setIsLoadingMore(false);
        }
    };
    const openVoteModal = async (post, type) => {
        const token = localStorage.getItem('jwt_token_jobcritic');
        try {
            const result = await API.post('/streaks/voters-list',
                {
                    vote_type: type,  // Ensure these values are set
                    streak_id: post.id
                }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Token from login
                },
            });

            setSelectedVotes({
                type,
                users: result.voters,
                postId: post.id
            });
        } catch (error) {
            console.error("Upload failed:", error);
            //            setImageError("Failed to upload image. Please try again.");
        }



    };

    const closeVoteModal = () => {
        setSelectedVotes(null);
    };
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 51 }, (_, i) => currentYear - i);
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const swiperRefs = useRef({});
    const containerRefs = useRef({});

    //     // Merged useEffect for both observers
    // const [visibleSwiperId, setVisibleSwiperId] = useState(null);

    // useEffect(() => {
    //     console.log("hell");
    //         if (Object.keys(containerRefs.current).length === 0) return; // wait for refs to be ready

    //     const observer = new IntersectionObserver(
    //         (entries) => {
    //             let maxVisible = 0;
    //             let currentId = null;

    //             entries.forEach((entry) => {
    //                 const postId = entry.target.getAttribute("data-id");
    //                 const visibleHeight = entry.intersectionRect.height;
    //                 console.log("vis--",visibleHeight);
    //                 console.log("post--",postId);
    //                 console.log("max--",maxVisible);
    //                 if (visibleHeight > maxVisible) {
    //                     console.log("hello--",postId,"--",visibleHeight)
    //                     maxVisible = visibleHeight;
    //                     currentId = postId;
    //                 }
    //             });

    //             if (currentId !== visibleSwiperId) {
    //                 setVisibleSwiperId(currentId);
    //             }
    //         },
    //         {
    //             threshold: Array.from({ length: 100 }, (_, i) => i / 100), // 0.0 to 0.99
    //         }
    //     );

    //     Object.entries(containerRefs.current).forEach(([postId, el]) => {
    //         if (el) observer.observe(el);
    //     });

    //     return () => observer.disconnect();
    // }, [posts]);

    // useEffect(() => {
    //     Object.entries(swiperRefs.current).forEach(([postId, swiper]) => {
    //         if (swiper && swiper.autoplay) {
    //             if (postId === visibleSwiperId) {
    //                 swiper.autoplay.start();
    //             } else {
    //                 swiper.autoplay.stop();
    //             }
    //         }
    //     });
    // }, [visibleSwiperId]);
    // Add this state to track visibility
    const [visibleSwiperId, setVisibleSwiperId] = useState(null);

    // IntersectionObserver useEffect
    useEffect(() => {
        if (Object.keys(containerRefs.current).length === 0) return; // Wait for refs to be populated

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const postId = entry.target.getAttribute("data-id");
                    const isFullyVisible = entry.intersectionRatio >= 0.95; // Adjust threshold for "fully visible"

                    if (isFullyVisible) {
                        setVisibleSwiperId(postId); // Set this Swiper as visible
                    } else if (visibleSwiperId === postId) {
                        setVisibleSwiperId(null); // Clear if it’s no longer fully visible
                    }
                });
            },
            {
                threshold: [0, 0.95, 1], // Check at 0%, 95%, and 100% visibility
            }
        );

        Object.values(containerRefs.current).forEach((el) => {
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [posts]);

    // Autoplay control useEffect
    useEffect(() => {
        Object.entries(swiperRefs.current).forEach(([postId, swiper]) => {
            if (swiper && swiper.autoplay) {
                if (postId === visibleSwiperId) {
                    swiper.autoplay.start();
                } else {
                    swiper.autoplay.stop();
                }
            }
        });
    }, [visibleSwiperId]);
    useEffect(() => {
        fetchData();
    }, []);

    const loadMorePosts = () => {
        if (currentPage < totalPages) {
            getMonthlyStreaks(selectedMonth, currentPage + 1);
        }
    };

    const handlePostSubmit = (e) => {
        e.preventDefault();
        if (postText.trim() === "") {
            setError("Post content cannot be empty!");
            return;
        }
        setPosts([
            {
                id: posts.length + 1,
                user: "Harwinder Singh",
                location: "@harwinder_singh",
                time: "Just now",
                content: postText,
                views: "0",
                upvotes: 0,
                downvotes: 0,
                comments: 0,
                reposts: 0,
                upvoted: false,
                downvoted: false,
            },
            ...posts
        ]);

        setPostText("");
        setError("");
    };

    //     console.log('posT_is', post, 'userData', userData);
    //     const id = post.id
    //     //const type = (userData.user_id == post.user_id);
    //     const token = localStorage.getItem('jwt_token_jobcritic');
    //     try {
    //         const result = await API.post('/streaks/vote',
    //             {
    //                 vote_type: type,  // Ensure these values are set
    //                 streak_id: id
    //             }, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //                 'Authorization': `Bearer ${token}`, // Token from login
    //             },
    //         });

    //         setPosts(posts.map((post) => {
    //             if (post.id === id) {
    //                 if (type === '1') {  // Upvote
    //                     const newUpvoted = !post.upvoted; // Toggle upvote
    //                     const newDownvoted = false; // Remove downvote if upvoted
    //                     return {
    //                         ...post,
    //                         upvoted: newUpvoted,
    //                         downvoted: newDownvoted,
    //                         upvotes: newUpvoted ? (parseInt(post.upvotes) || 0) + 1 : Math.max(0, parseInt(post.upvotes) - 1), // Toggle upvote count with parseInt
    //                         downvotes: post.downvoted ? Math.max(0, parseInt(post.downvotes) - 1) : parseInt(post.downvotes), // Remove downvote if switching with parseInt
    //                     };

    //                 } else {  // Downvote
    //                     const newDownvoted = !post.downvoted; // Toggle downvote
    //                     const newUpvoted = false; // Remove upvote if downvoted

    //                     return {
    //                         ...post,
    //                         upvoted: newUpvoted,
    //                         downvoted: newDownvoted,
    //                         downvotes: newDownvoted ? (parseInt(post.downvotes) || 0) + 1 : Math.max(0, parseInt(post.downvotes) - 1), // Toggle downvote count with parseInt
    //                         upvotes: post.upvoted ? Math.max(0, parseInt(post.upvotes) - 1) : parseInt(post.upvotes), // Remove upvote if switching with parseInt
    //                     };
    //                 }


    //             }
    //             return post;
    //         }));

    //     } catch (error) {
    //         console.error("Upload failed:", error);
    //         //            setImageError("Failed to upload image. Please try again.");
    //     }

    // };
    // const toggleVote = async (post, type) => {
    //     const id = post.id;
    //     const token = localStorage.getItem('jwt_token_jobcritic');
    //     const isUpvote = type === '1'; // Upvote corresponds to vote_type = 1
    //     const currentUpvoted = post.upvoted;
    //     const currentDownvoted = post.downvoted;
    //     const currentUpvotes = parseInt(post.upvotes) || 0;
    //     const currentDownvotes = parseInt(post.downvotes) || 0;

    //     try {
    //         // Determine new state based on current state and action
    //         let newUpvoted = currentUpvoted;
    //         let newDownvoted = currentDownvoted;
    //         let newUpvotes = currentUpvotes;
    //         let newDownvotes = currentDownvotes;

    //         if (isUpvote) {
    //             if (currentUpvoted) {
    //                 // Remove upvote (toggle off)
    //                 newUpvoted = false;
    //                 newUpvotes -= 1;
    //             } else {
    //                 // Add upvote or switch from downvote
    //                 newUpvoted = true;
    //                 newUpvotes += 1;
    //                 if (currentDownvoted) {
    //                     newDownvoted = false;
    //                     newDownvotes -= 1;
    //                 }
    //             }
    //         } else {
    //             if (currentDownvoted) {
    //                 // Remove downvote (toggle off)
    //                 newDownvoted = false;
    //                 newDownvotes -= 1;
    //             } else {
    //                 // Add downvote or switch from upvote
    //                 newDownvoted = true;
    //                 newDownvotes += 1;
    //                 if (currentUpvoted) {
    //                     newUpvoted = false;
    //                     newUpvotes -= 1;
    //                 }
    //             }
    //         }

    //         // Optimistic UI update
    //         setPosts(prevPosts => prevPosts.map(p =>
    //             p.id === id ? { ...p, upvoted: newUpvoted, downvoted: newDownvoted, upvotes: newUpvotes, downvotes: newDownvotes } : p
    //         ));

    //         // Send vote request to server with vote_type = 1, 2, or null
    //         const voteTypeToSend = isUpvote
    //             ? (currentUpvoted ? null : 1) // Remove if already upvoted, else set to 1
    //             : (currentDownvoted ? null : 2); // Remove if already downvoted, else set to 2

    //         const result = await API.post('/streaks/vote', {
    //             vote_type: voteTypeToSend, // 1 for upvote, 2 for downvote, null to remove
    //             streak_id: id,
    //             streak: post
    //         }, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //                 'Authorization': `Bearer ${token}`,
    //             },
    //         });

    //         // Sync with server response
    //         if (result && result.streak) { // Adjust based on actual API response
    //             const updatedPost = result.streak;
    //             setPosts(prevPosts => prevPosts.map(p =>
    //                 p.id === id ? {
    //                     ...p,
    //                     upvoted: updatedPost.vote_type === 1,
    //                     downvoted: updatedPost.vote_type === 2,
    //                     upvotes: parseInt(updatedPost.upvotes) || newUpvotes,
    //                     downvotes: parseInt(updatedPost.downvotes) || newDownvotes
    //                 } : p
    //             ));
    //         } else {
    //             // Refetch if API doesn't return updated data
    //             await getMonthlyStreaks(selectedMonth);
    //         }

    //     } catch (error) {
    //         console.error("Vote failed:", error);
    //         // Roll back to original state on error
    //         setPosts(prevPosts => prevPosts.map(p =>
    //             p.id === id ? { ...p, upvoted: currentUpvoted, downvoted: currentDownvoted, upvotes: currentUpvotes, downvotes: currentDownvotes } : p
    //         ));
    //     }
    // };
    const toggleVote = async (post, type) => {
        const id = post.id;
        const token = localStorage.getItem('jwt_token_jobcritic');
        const isUpvote = type === '1';
        const currentUpvoted = post.upvoted;
        const currentDownvoted = post.downvoted;
        const currentUpvotes = parseInt(post.upvotes) || 0;
        const currentDownvotes = parseInt(post.downvotes) || 0;

        try {
            let newUpvoted = currentUpvoted;
            let newDownvoted = currentDownvoted;
            let newUpvotes = currentUpvotes;
            let newDownvotes = currentDownvotes;

            if (isUpvote) {
                if (currentUpvoted) {
                    newUpvoted = false;
                    newUpvotes -= 1;
                } else {
                    newUpvoted = true;
                    newUpvotes += 1;
                    if (currentDownvoted) {
                        newDownvoted = false;
                        newDownvotes -= 1;
                    }
                }
            } else {
                if (currentDownvoted) {
                    newDownvoted = false;
                    newDownvotes -= 1;
                } else {
                    newDownvoted = true;
                    newDownvotes += 1;
                    if (currentUpvoted) {
                        newUpvoted = false;
                        newUpvotes -= 1;
                    }
                }
            }

            setPosts(prevPosts => prevPosts.map(p =>
                p.id === id ? { ...p, upvoted: newUpvoted, downvoted: newDownvoted, upvotes: newUpvotes, downvotes: newDownvotes } : p
            ));

            const voteTypeToSend = isUpvote
                ? (currentUpvoted ? null : 1)
                : (currentDownvoted ? null : 2);

            const result = await API.post('/streaks/vote', {
                vote_type: voteTypeToSend,
                streak_id: id
            }, {
                headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}` },
            });

            if (result && result.streak) {
                setPosts(prevPosts => prevPosts.map(p =>
                    p.id === id ? {
                        ...p,
                        upvoted: result.streak.vote_type === 1,
                        downvoted: result.streak.vote_type === 2,
                        upvotes: result.streak.upvotes,
                        downvotes: result.streak.downvotes
                    } : p
                ));
            } else {
                await getMonthlyStreaks(selectedMonth);
            }

        } catch (error) {
            console.error("Vote failed:", error);
            setPosts(prevPosts => prevPosts.map(p =>
                p.id === id ? { ...p, upvoted: currentUpvoted, downvoted: currentDownvoted, upvotes: currentUpvotes, downvotes: currentDownvotes } : p
            ));
        }
    };


    const toggleMenu = (commentId) => {
        setMenuOpen(menuOpen === commentId ? null : commentId);
    };

    // Click Outside Handler
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if any menu is open
            if (menuOpen && menuRefs.current[menuOpen] && !menuRefs.current[menuOpen].contains(event.target)) {
                setMenuOpen(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    const toggleReplies = (postId, commentId) => {
        setPostComments(prev => ({
            ...prev,
            [postId]: {
                ...prev[postId],
                comments: prev[postId].comments.map(comment =>
                    comment.id === commentId ? { ...comment, showAllReplies: !comment.showAllReplies } : comment
                )
            }
        }));
    };
    const fetchDataUser = async () => {
        try {
            const endpoint = `/user`;
            const res = await API.get(endpoint);
            if (res.user) {
                const userData = {
                    user_id: res.user.user_id,
                    name: res.user.name || "Unknown User",
                    profile_image: DOMAIN_URL + res.user.profile_image,
                    profile_image_without_domain: res.user.profile_image,
                    country_name: res.user.country_name,
                    state_name: res.user.state_name,
                    city_name: res.user.city_name,
                    profile_title: res.user.profile_title,

                };
                setUserData(userData);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setLoading(false); // Set loading to false regardless of success or failure
        }
    };

    useEffect(() => {
        fetchDataUser();
        const initialMonth = new Date().toLocaleString("default", { month: "long" });
        setSelectedMonth(initialMonth);
        getMonthlyStreaks(initialMonth, 1); // Fetch first 10 posts
        fetchDataUserUpdateP();
    }, []);
    const [currentSlide, setCurrentSlide] = useState({}); // Track current slide for each post
    const handleDotClick = (postId, index) => {
        setCurrentSlide((prev) => ({
            ...prev,
            [postId]: index,
        }));
    };
    const fetchDataUserUpdateP = async () => {
        try {
            const res = await API.get("/user/check_userdetial");
            const { profile_updated } = res.result || {};
            const hasSeenModal = document.cookie.includes("welcome_modal_seen=true");
            if (parseInt(profile_updated) === 0 && !hasSeenModal) {
                setShowWelcomeModal(true);
            } else {
                setShowWelcomeModal(false);
            }
        } catch (error) {
            console.error("API error:", error);
        }
    };

    // Autoplay control useEffect
    useEffect(() => {
        Object.entries(swiperRefs.current).forEach(([postId, swiper]) => {
            if (swiper && swiper.autoplay) {
                if (postId === visibleSwiperId) {
                    swiper.autoplay.start();
                } else {
                    swiper.autoplay.stop();
                }
            }
        });
    }, [visibleSwiperId]);

    // Infinite scroll observer
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && currentPage < totalPages && !isLoadingMore) {
                    getMonthlyStreaks(selectedMonth, currentPage + 1);
                }
            },
            {
                root: null,
                rootMargin: '100px',
                threshold: 0.1,
            }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) {
                observer.unobserve(loaderRef.current);
            }
        };
    }, [currentPage, totalPages, isLoadingMore, selectedMonth]);

    return (
        <div>
            <MainHeader />
            {loading ? (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50">
                    <Loader />
                </div>
            ) : (
                <>
                    <section className="pb-12 px-4 pt-[120px] sm:pt-[40px] md:pt-[40px]  custm-bg ">
                        <Container>
                            <Row className="p-6 pt-0 relative md:p-0 sm:p-0 xs:p-0">
                                {/* Left Sidebar - Profile Card */}
                                <Col lg={3} md={12} sm={12} className="custm-bg pl-0 sm:pb-[14px] md:pt-[14px] md:pb-[14px] sm:pr-0 md:pr-0 ">
                                    <div className="sticky top-[70px]">
                                        <div className="p-4 border rounded-lg bg-white ">
                                            <div className="flex flex-col items-left">
                                                <Link to="/employee_detail" className="cursor-pointer">
                                                    <img
                                                    crossorigin="anonymous"
                                                        src={userData?.profile_image || IMAGE_PATHS.USER}
                                                        className="w-[80px] h-[80px] rounded-full object-cover border border-gray-300"
                                                        alt="User Avatar"
                                                    />
                                                </Link>
                                                <h4 className="text-lg font-bold text-gray-900 mt-2 mb-1">{userData?.name}</h4>

                                                {
                                                    userData && userData.profile_title != null && (<p className="font-medium text-[16px] text-gray-700 leading-[1.5]">{userData?.profile_title.length > 50 ? `${userData?.profile_title.substring(0, 50)}... ` : userData?.profile_title || ''}</p>)
                                                }

                                                <div className="flex items-start space-x-3 mb-3">
                                                    <div className="mt-[8px]">
                                                        <span className="text-[34px] font-bold text-gray-900 lt break-auto-phrase">{ratings.overall_rating.toFixed(1)}</span>
                                                    </div>
                                                    <div className="leading-[1.4]">
                                                    <InfoTooltipRating className="text-[16px] font-bold text-gray-900" rating={ratings.overall_rating} />
                                                        <div className="flex items-center  mb-2">

                                                            <StarRating rating={ratings.overall_rating} starSize={15} />
                                                            <span className="text-gray-600 text-[14px] ml-2 " >
                                                                {ratings.total_reviews > 0 ? `${ratings.total_reviews} Reviews` : "No Reviews"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Career Streak Section 
                                    <div className="p-4 border rounded-lg bg-white mt-4">
                                        <h4 className="text-lg font-bold text-gray-900 mt-0 mb-4">Career Streak</h4>
                                        <div className="relative border-gray-300 pl-4 max-h-[380px] overflow-auto">
                                            {years.map((year) => (
                                                <div key={year} className="mb-2">
                                                    <div
                                                        className={`cursor-pointer text-lg font-semibold mb-1 ${selectedYear === year ? "yellow-class" : "text-gray-700"}`}
                                                        onClick={() => setSelectedYear(year === selectedYear ? null : year)}
                                                    >
                                                        {year}
                                                    </div>

                                                    <div
                                                        className={`ml-4 mt-2 border-l-2 border-gray-300 pl-4 overflow-hidden transition-all duration-700 ease-in-out ${selectedYear === year ? "max-h-k opacity-100 fadeInSlideDown" : "max-h-0 opacity-0"
                                                            }`}
                                                    >
                                                        {months
                                                            .slice(0, year === new Date().getFullYear() ? new Date().getMonth() + 1 : 12) // Show all months for past years
                                                            .reverse()
                                                            .map((month) => (
                                                                <div
                                                                    key={month}
                                                                    className={`cursor-pointer text-sm py-1 ${selectedMonth === month ? "yellow-class font-bold" : "text-gray-600"}`}
                                                                    onClick={() => getMonthlyStreaks(month)}
                                                                >
                                                                    - {month}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    */}

                                </Col>

                                {/* Right Sidebar - Posts */}
                                <Col lg={9} md={12} sm={12} className="sm:pr-[0px] sm:pl-[0px] md:pr-[0px] md:pl-[0px]">
                                    <WebsiteStep />
                                    <div className="flex mb-3 bg-white p-4 border border-gray-300 rounded-lg ">
                                        <img
                                        crossorigin="anonymous"
                                            src={userData?.profile_image || IMAGE_PATHS.USER}
                                            className="w-[50px] h-[50px] rounded-full border border-gray-300 mr-3"
                                            alt="User"
                                        />

                                        <Form onSubmit={handlePostSubmit} className="w-full">
                                            <Form.Group>
                                                {/* Clickable Textarea that opens modal */}
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    placeholder="Post your streak..."
                                                    value={postText}
                                                    style={{ resize: "none" }}
                                                    onClick={() => setShowModal(true)} // Open modal on click
                                                    className="form-control fomc-cls cursor-pointer"
                                                    readOnly // Prevent direct typing
                                                />
                                            </Form.Group>
                                        </Form>
                                    </div>

                                    {selectedMonth ? (
                                        loading ? (
                                            <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50">
                                                <Loader />
                                            </div>
                                        ) :
                                            posts.length > 0 ? (
                                                posts.map(post => (
                                                    <div key={post.id} >
                                                        <div key={post.id} className="p-4 pl-0 pr-0 bg-white border border-gray-300 rounded-lg mb-3 pb-2">
                                                            <div className="flex items-center justify-between mb-1">
                                                                <div className="flex items-center mb-2">
                                                                    <img
                                                                    crossorigin="anonymous"
                                                                        src={`${DOMAIN_URL + post.profile_image}?t=${Date.now()}`}
                                                                        className="w-[50px] h-[50px] rounded-full object-cover border border-gray-300 mr-3"
                                                                        alt="User Avatar"
                                                                    />
                                                                    <div>
                                                                        <h4 className="text-lg font-bold text-gray-900 text-lg mb-0 sm:text-[13px]">{post.username}</h4>
                                                                        {
                                                                            post.profile_title != null && (<p className="text-sm text-gray-600">{post.profile_title.length > 50 ? `${post.profile_title.substring(0, 50)}... ` : post.profile_title}</p>)
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className="relative flex items-center" ref={(el) => (menuRefs.current[post.id] = el)}>
                                                                    <p className="text-xs text-gray-500 sm:w-max md:w-max ">{formatDate(new Date(post.time))}</p>
                                                                    <button
                                                                        className="rond-cls relative inline-block ml-1"
                                                                        onClick={() => toggleMenu(post.id)}
                                                                    >
                                                                        <i className="fas fa-ellipsis-h cursor-pointer text-gray-700 hover:text-black  pl-[1px]"></i>
                                                                    </button>
                                                                    {menuOpen === post.id && (
                                                                        <div className="absolute right-[34px] top-0 w-max bg-white  rounded-lg shadow-lg z-10">
                                                                            <div className="absolute right-[34px] top-0 w-max bg-white  rounded-lg shadow-lg z-10">
                                                                                {post.user_id != userData?.user_id && (
                                                                                    <div className="relative inline-block">
                                                                                        {/* Tooltip Box */}
                                                                                        <div className="absolute w-max top-3  transform -translate-x-1/2 bg-white border border-gray-300 rounded-md shadow-md px-4 py-0">
                                                                                            {/* Triangle Pointer */}
                                                                                            <div className="absolute -top-2 right-2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></div>
                                                                                            <button className="block w-full text-left  py-2 text-sm text-gray-700 " onClick={(event) => {
                                                                                                event.stopPropagation();
                                                                                                setSelectedValue({ streakId: post.id });
                                                                                                setPopupAction("reportpost");
                                                                                                setShowPopup(true);
                                                                                            }}>
                                                                                                {/* <i className="fas fa-flag mr-2 text-red-500"></i>  */}
                                                                                                Report
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            </div>
                                                                            {post.user_id == userData?.user_id && (
                                                                                //      <button
                                                                                //      className="block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-200"
                                                                                //      onClick={(event) => {
                                                                                //          event.stopPropagation();
                                                                                //          setSelectedValue({ streakId: post.id });
                                                                                //          setPopupAction("deletepost");
                                                                                //          setShowPopup(true);
                                                                                //      }}
                                                                                //  >
                                                                                //      {/* <i className="fas fa-trash mr-2 text-red-500"></i>  */}
                                                                                //      Delete
                                                                                //  </button>
                                                                                <div className="relative inline-block">
                                                                                    {/* Tooltip Box */}
                                                                                    <div className="absolute w-max top-3  transform -translate-x-1/2 bg-white border border-gray-300 rounded-md shadow-md px-4 py-1">
                                                                                        {/* Triangle Pointer */}
                                                                                        <div className="absolute -top-2 right-2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></div>

                                                                                        <button
                                                                                            className="w-full text-center text-sm font-medium text-gray-700  transition-all duration-200 rounded-md"
                                                                                            onClick={(event) => {
                                                                                                event.stopPropagation();
                                                                                                setSelectedValue({ streakId: post.id });
                                                                                                setPopupAction("deletepost");
                                                                                                setShowPopup(true);
                                                                                            }}
                                                                                        >
                                                                                            Delete
                                                                                        </button>
                                                                                    </div>
                                                                                </div>



                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <p className="text-gray-800 mb-3 kd">
                                                                {post.content.split(" ").length > 25 && !post.showFullContent
                                                                    ? `${post.content.split(" ").slice(0, 25).join(" ")}... `
                                                                    : post.content}
                                                                {post.content.split(" ").length > 25 && (
                                                                    <button
                                                                        className="text-gray-500 font-medium ml-2 cursor-pointer hover:underline"
                                                                        onClick={() => setPosts(posts.map(p =>
                                                                            p.id === post.id ? { ...p, showFullContent: !p.showFullContent } : p
                                                                        ))}
                                                                    >
                                                                        {post.showFullContent ? "Read Less" : "Read More"}
                                                                    </button>
                                                                )}
                                                            </p>
                                                            {/* {
                                                            post.imageUrl && post.imageUrl.length > 1 ? (



                                                                <div className="media-container slider-container">
                                                                    <div className="slider">
                                                                        {post.imageUrl.map((attachment, index) => (
                                                                        <div
                                                                            key={index}
                                                                            className={`slide ${index === currentSlide[post._id] ? 'active' : ''}`}
                                                                        >
                                                                            {attachment.endsWith('.mp4') || attachment.endsWith('.mov') ? (
                                                                            <video controls src={DOMAIN_URL+attachment} className="media-full" />
                                                                            ) : (
                                                                            <img src={DOMAIN_URL+attachment} alt={`Attachment ${index}`} className="media-full" />
                                                                            )}
                                                                        </div>
                                                                        ))}
                                                                    </div>
                                                                    <div className="slider-dots">
                                                                        {post.imageUrl.map((_, index) => (
                                                                        <span
                                                                            key={index}
                                                                            className={`dot ${index === currentSlide[post._id] ? 'active' : ''}`}
                                                                            onClick={() => handleDotClick(post._id, index)}
                                                                        />
                                                                        ))}
                                                                    </div>
                                                                    </div>

                                                                // <div className="media-container">
                                                                //     {post.imageUrl.slice(0, 4).map((attachment, index) => (
                                                                //         <div key={index} className="media-item">
                                                                //         {attachment.endsWith('.mp4') || attachment.endsWith('.mov') ? (
                                                                //             <video controls src={DOMAIN_URL+attachment} className="media-video" />
                                                                //         ) : (
                                                                //             <img src={DOMAIN_URL+attachment} alt={`Attachment ${index}`} className="media-image" />
                                                                //         )}
                                                                //         {index === 3 && post.imageUrl.length > 4 && (
                                                                //             <div className="more-images">
                                                                //             +{post.imageUrl.length - 4}
                                                                //             </div>
                                                                //         )}
                                                                //         </div>
                                                                //     ))}
                                                                //     </div>
                                                            ): post.imageUrl && post.imageUrl.length === 1?(
                                                                <div className="media-container single-media">
                                                                    <div className="media-overlay">
                                                                        
                                                                        {post.imageUrl && post.imageUrl.length === 1 ? (
                                                                        post.imageUrl[0].endsWith('.mp4') || post.imageUrl[0].endsWith('.mov') ? (
                                                                            <video controls src={DOMAIN_URL+post.imageUrl[0]} className="media-full" />
                                                                        ) : (
                                                                            <img src={DOMAIN_URL+post.imageUrl[0]} alt="Single Media" className="media-full" />
                                                                        )
                                                                        ) :  (<></>)}
                                                                    </div>
                                                                    </div>
                                                            ):(<></>)
                                                        } */}
                                                            {post.imageUrl && post.imageUrl.length > 1 ? (
                                                                <div
                                                                    key={post.id}
                                                                    data-id={post.id}
                                                                    ref={(el) => (containerRefs.current[post.id] = el)}
                                                                    className="media-container slider-container relative w-full h-[500px] rounded-xl overflow-hidden"
                                                                >
                                                                    <Swiper
                                                                        modules={[Pagination, Autoplay, Navigation]}
                                                                        autoplay={{ delay: 5000, disableOnInteraction: false }}
                                                                        pagination={{ clickable: true }}
                                                                        navigation
                                                                        onSwiper={(swiper) => {
                                                                            swiperRefs.current[post.id] = swiper;
                                                                            swiper.autoplay?.stop();
                                                                        }}
                                                                        className="w-full h-full"
                                                                    >
                                                                        {post.imageUrl.map((attachment, index) => (
                                                                            <SwiperSlide key={index} className="w-full h-full bg-black">
                                                                                {attachment.endsWith(".mp4") || attachment.endsWith(".mov") ? (
                                                                                    <video
                                                                                    crossorigin="anonymous"
                                                                                        controls
                                                                                        src={DOMAIN_URL + attachment}
                                                                                        className="w-full h-full object-contain"
                                                                                    />
                                                                                ) : (
                                                                                    <img
                                                                                    crossorigin="anonymous"
                                                                                        src={DOMAIN_URL + attachment}
                                                                                        alt={`Attachment ${index}`}
                                                                                        className="w-full h-full object-contain"
                                                                                    />
                                                                                )}
                                                                            </SwiperSlide>
                                                                        ))}
                                                                    </Swiper>
                                                                </div>
                                                            ) : post.imageUrl && post.imageUrl.length === 1 ? (
                                                                <div className="w-full h-[500px] bg-black rounded-xl overflow-hidden media-container single-media">
                                                                    {post.imageUrl[0].endsWith(".mp4") || post.imageUrl[0].endsWith(".mov") ? (
                                                                        <video
                                                                        crossorigin="anonymous"
                                                                            controls
                                                                            src={DOMAIN_URL + post.imageUrl[0]}
                                                                            className="w-full h-full object-contain"
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                        crossorigin="anonymous"
                                                                            src={DOMAIN_URL + post.imageUrl[0]}
                                                                            alt="Single Media"
                                                                            className="w-full h-full object-contain"
                                                                        />
                                                                    )}
                                                                </div>
                                                            ) : null}






                                                            {/* {post.imageUrl && post.imageUrl != '' && (
                                                            <img
                                                                src={DOMAIN_URL + post.imageUrl[0]}
                                                                alt="Post Image"
                                                                className="w-full rounded-lg mt-2"
                                                            />
                                                        )} */}
                                                            <hr className="border-gray-300  2 " />
                                                            <div className="flex mt-3 text-gray-600 text-sm justify-between items-center">
                                                                <div className="flex items-center cursor-pointer px-3 py-1 sm:!px-0 sm:!py-0">
                                                                    {/* <button onClick={() => toggleVote(post, '1')} className="ml-2 mr-1">
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 375 374.999991"
                                                                            width="20" // Adjust size
                                                                            height="20"
                                                                            fill={post.vote_type == 1 ? "#3b82f6" : "#545454"}
                                                                            className=" hover:fill-[#FFB000]"
                                                                        >
                                                                            <path d="M 187.5 0 C 83.945312 0 0 83.945312 0 187.5 C 0 291.054688 83.945312 375 187.5 375 C 291.054688 375 375 291.054688 375 187.5 C 375 83.945312 291.054688 0 187.5 0 Z M 121.535156 262.117188 C 121.535156 267.046875 117.539062 271.042969 112.609375 271.042969 L 85.832031 271.042969 C 80.902344 271.042969 76.902344 267.046875 76.902344 262.117188 L 76.902344 150.535156 C 76.902344 145.605469 80.902344 141.609375 85.832031 141.609375 L 112.609375 141.609375 C 117.539062 141.609375 121.535156 145.605469 121.535156 150.535156 Z M 304.652344 171.335938 L 283.863281 251.023438 C 280.785156 262.8125 270.136719 271.042969 257.953125 271.042969 L 184.019531 271.042969 C 164.300781 271.042969 148.316406 255.054688 148.316406 235.335938 L 148.316406 156.398438 C 148.316406 146.929688 152.078125 137.847656 158.773438 131.152344 L 210.667969 79.257812 C 213.613281 76.3125 217.601562 74.660156 221.761719 74.660156 C 233.605469 74.660156 241.175781 87.28125 235.601562 97.730469 L 219.34375 128.21875 C 216.109375 134.285156 220.503906 141.609375 227.375 141.609375 L 281.6875 141.609375 C 294.792969 141.609375 305.421875 152.234375 305.421875 165.34375 C 305.417969 167.363281 305.160156 169.378906 304.652344 171.335938 Z" />
                                                                        </svg>
                                                                    </button>

                                                                    <span
                                                                        className="text-gray-700 cursor-pointer hover:underline hover:text-black transition"
                                                                        onClick={() => openVoteModal(post, "1")}
                                                                    >
                                                                        {post.upvotes}
                                                                    </span>
                                                                    <button
                                                                        onClick={() => toggleVote(post, '2')}
                                                                        className="ml-2 mr-1 w-6 h-6  hover:fill-[#FFB000]"
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 375 374.999991"
                                                                            width="20" // Adjust size
                                                                            height="20"
                                                                            fill={post.vote_type == 2 ? "#ef4444" : "#545454"} // Red if downvoted, gray otherwise
                                                                            className=" hover:fill-[#FFB000]" // Add hover effect
                                                                        >
                                                                            <path d="M 187.5 375 C 291.054688 375 375 291.054688 375 187.5 C 375 83.945312 291.054688 0 187.5 0 C 83.945312 0 0 83.945312 0 187.5 C 0 291.054688 83.945312 375 187.5 375 Z M 253.464844 112.882812 C 253.464844 107.953125 257.460938 103.957031 262.390625 103.957031 L 289.167969 103.957031 C 294.097656 103.957031 298.09375 107.953125 298.09375 112.882812 L 298.09375 224.464844 C 298.09375 229.394531 294.097656 233.390625 289.167969 233.390625 L 262.390625 233.390625 C 257.460938 233.390625 253.464844 229.394531 253.464844 224.464844 Z M 70.347656 203.664062 L 91.136719 123.976562 C 94.214844 112.1875 104.863281 103.957031 117.046875 103.957031 L 190.980469 103.957031 C 210.699219 103.957031 226.683594 119.945312 226.683594 139.664062 L 226.683594 218.601562 C 226.683594 228.070312 222.921875 237.152344 216.226562 243.847656 L 164.332031 295.742188 C 161.386719 298.6875 157.398438 300.339844 153.238281 300.339844 C 141.394531 300.339844 133.824219 287.71875 139.398438 277.269531 L 155.65625 246.78125 C 158.890625 240.714844 154.496094 233.390625 147.625 233.390625 L 93.3125 233.390625 C 80.207031 233.390625 69.578125 222.765625 69.578125 209.65625 C 69.582031 207.636719 69.839844 205.621094 70.347656 203.664062 Z" />
                                                                        </svg>
                                                                    </button>


                                                                    <span
                                                                        className="text-gray-700 cursor-pointer hover:underline hover:text-black transition"
                                                                        onClick={() => openVoteModal(post, "2")}
                                                                    >
                                                                        {post.downvotes}
                                                                    </span> */}
                                                                    {/* <div className="flex items-center cursor-pointer px-3 py-1 sm:p-0 "> */}
                                                                    <button onClick={() => toggleVote(post, '1')} className="ml-2 mr-1">
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 375 374.999991"
                                                                            width="20"
                                                                            height="20"
                                                                            fill={post.upvoted ? "#3b82f6" : "#545454"}
                                                                            className="hover:fill-[#FFB000]"
                                                                        >
                                                                            <path d="M 187.5 0 C 83.945312 0 0 83.945312 0 187.5 C 0 291.054688 83.945312 375 187.5 375 C 291.054688 375 375 291.054688 375 187.5 C 375 83.945312 291.054688 0 187.5 0 Z M 121.535156 262.117188 C 121.535156 267.046875 117.539062 271.042969 112.609375 271.042969 L 85.832031 271.042969 C 80.902344 271.042969 76.902344 267.046875 76.902344 262.117188 L 76.902344 150.535156 C 76.902344 145.605469 80.902344 141.609375 85.832031 141.609375 L 112.609375 141.609375 C 117.539062 141.609375 121.535156 145.605469 121.535156 150.535156 Z M 304.652344 171.335938 L 283.863281 251.023438 C 280.785156 262.8125 270.136719 271.042969 257.953125 271.042969 L 184.019531 271.042969 C 164.300781 271.042969 148.316406 255.054688 148.316406 235.335938 L 148.316406 156.398438 C 148.316406 146.929688 152.078125 137.847656 158.773438 131.152344 L 210.667969 79.257812 C 213.613281 76.3125 217.601562 74.660156 221.761719 74.660156 C 233.605469 74.660156 241.175781 87.28125 235.601562 97.730469 L 219.34375 128.21875 C 216.109375 134.285156 220.503906 141.609375 227.375 141.609375 L 281.6875 141.609375 C 294.792969 141.609375 305.421875 152.234375 305.421875 165.34375 C 305.417969 167.363281 305.160156 169.378906 304.652344 171.335938 Z" />
                                                                        </svg>
                                                                    </button>
                                                                    <span
                                                                        className="text-gray-700 cursor-pointer hover:underline hover:text-black transition "
                                                                        onClick={() => openVoteModal(post, "1")}
                                                                    >
                                                                        {post.upvotes}
                                                                    </span>
                                                                    <button onClick={() => toggleVote(post, '2')} className="ml-2 mr-1  hover:fill-[#FFB000]">
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 375 374.999991"
                                                                            width="23"
                                                                            height="20"
                                                                            fill={post.downvoted ? "#ef4444" : "#545454"}
                                                                            className="hover:fill-[#FFB000]"
                                                                        >
                                                                            <path d="M 187.5 375 C 291.054688 375 375 291.054688 375 187.5 C 375 83.945312 291.054688 0 187.5 0 C 83.945312 0 0 83.945312 0 187.5 C 0 291.054688 83.945312 375 187.5 375 Z M 253.464844 112.882812 C 253.464844 107.953125 257.460938 103.957031 262.390625 103.957031 L 289.167969 103.957031 C 294.097656 103.957031 298.09375 107.953125 298.09375 112.882812 L 298.09375 224.464844 C 298.09375 229.394531 294.097656 233.390625 289.167969 233.390625 L 262.390625 233.390625 C 257.460938 233.390625 253.464844 229.394531 253.464844 224.464844 Z M 70.347656 203.664062 L 91.136719 123.976562 C 94.214844 112.1875 104.863281 103.957031 117.046875 103.957031 L 190.980469 103.957031 C 210.699219 103.957031 226.683594 119.945312 226.683594 139.664062 L 226.683594 218.601562 C 226.683594 228.070312 222.921875 237.152344 216.226562 243.847656 L 164.332031 295.742188 C 161.386719 298.6875 157.398438 300.339844 153.238281 300.339844 C 141.394531 300.339844 133.824219 287.71875 139.398438 277.269531 L 155.65625 246.78125 C 158.890625 240.714844 154.496094 233.390625 147.625 233.390625 L 93.3125 233.390625 C 80.207031 233.390625 69.578125 222.765625 69.578125 209.65625 C 69.582031 207.636719 69.839844 205.621094 70.347656 203.664062 Z" />
                                                                        </svg>
                                                                    </button>
                                                                    <span
                                                                        className="text-gray-700 cursor-pointer hover:underline hover:text-black transition sm:ml-[4px]"
                                                                        onClick={() => openVoteModal(post, "2")}
                                                                    >
                                                                        {post.downvotes}
                                                                    </span>
                                                                    {/* </div> */}
                                                                    <div className="flex items-center cursor-pointer " >
                                                                        <button
                                                                            onClick={() => toggleCommentBox(post.id)}
                                                                            className="ml-2 mr-1 "
                                                                        >

                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="23" zoomAndPan="magnify" viewBox="0 0 375 374.999991" height="20" preserveAspectRatio="xMidYMid meet" version="1.0"
                                                                                className=" hover:fill-[#FFB000]"
                                                                            >
                                                                                <rect x="-37.5" width="450" fill="#ffffff" y="-37.499999" height="449.999989" fill-opacity="1"
                                                                                />
                                                                                <rect x="-37.5" width="450" fill="#ffffff" y="-37.499999" height="449.999989" fill-opacity="1"
                                                                                />
                                                                                <path fill="#545454" className=" hover:fill-[#FFB000]" d="M 375.285156 187.457031 C 375.285156 190.527344 375.207031 193.597656 375.058594 196.664062 C 374.90625 199.730469 374.679688 202.789062 374.378906 205.84375 C 374.078125 208.898438 373.703125 211.945312 373.253906 214.980469 C 372.800781 218.019531 372.277344 221.042969 371.679688 224.054688 C 371.082031 227.0625 370.40625 230.058594 369.660156 233.035156 C 368.914062 236.015625 368.097656 238.972656 367.207031 241.910156 C 366.316406 244.847656 365.351562 247.761719 364.316406 250.652344 C 363.285156 253.542969 362.179688 256.40625 361.003906 259.242188 C 359.828125 262.078125 358.585938 264.882812 357.273438 267.660156 C 355.960938 270.433594 354.582031 273.175781 353.132812 275.882812 C 351.6875 278.589844 350.175781 281.261719 348.597656 283.894531 C 347.019531 286.527344 345.375 289.117188 343.671875 291.671875 C 341.964844 294.222656 340.199219 296.734375 338.371094 299.199219 C 336.539062 301.664062 334.652344 304.082031 332.707031 306.457031 C 330.757812 308.828125 328.753906 311.152344 326.691406 313.429688 C 324.628906 315.703125 322.515625 317.925781 320.34375 320.097656 C 318.171875 322.265625 315.949219 324.382812 313.675781 326.445312 C 311.398438 328.503906 309.078125 330.511719 306.703125 332.457031 C 304.332031 334.40625 301.910156 336.292969 299.445312 338.121094 C 296.980469 339.949219 294.46875 341.71875 291.917969 343.421875 C 289.367188 345.128906 286.773438 346.769531 284.140625 348.347656 C 281.507812 349.925781 278.835938 351.441406 276.128906 352.886719 C 273.421875 354.332031 270.679688 355.714844 267.90625 357.027344 C 265.128906 358.339844 262.324219 359.582031 259.488281 360.757812 C 256.652344 361.933594 253.789062 363.035156 250.898438 364.070312 C 248.007812 365.105469 245.09375 366.066406 242.15625 366.957031 C 239.21875 367.851562 236.261719 368.667969 233.28125 369.414062 C 230.304688 370.160156 227.3125 370.832031 224.300781 371.433594 C 221.289062 372.03125 218.265625 372.554688 215.230469 373.003906 C 212.191406 373.457031 209.144531 373.832031 206.089844 374.132812 C 203.035156 374.433594 199.976562 374.660156 196.910156 374.808594 C 193.84375 374.960938 190.773438 375.035156 187.707031 375.035156 C 184.636719 375.035156 181.566406 374.960938 178.5 374.808594 C 175.433594 374.660156 172.375 374.433594 169.320312 374.132812 C 166.265625 373.832031 163.21875 373.457031 160.183594 373.003906 C 157.144531 372.554688 154.121094 372.03125 151.109375 371.433594 C 148.101562 370.832031 145.105469 370.160156 142.128906 369.414062 C 139.148438 368.667969 136.191406 367.851562 133.253906 366.960938 C 130.316406 366.066406 127.402344 365.105469 124.511719 364.070312 C 121.621094 363.035156 118.757812 361.933594 115.921875 360.757812 C 113.085938 359.582031 110.28125 358.339844 107.503906 357.027344 C 104.730469 355.714844 101.988281 354.335938 99.28125 352.886719 C 96.574219 351.441406 93.902344 349.929688 91.269531 348.351562 C 88.636719 346.769531 86.046875 345.128906 83.492188 343.425781 C 80.941406 341.71875 78.429688 339.953125 75.964844 338.121094 C 73.5 336.292969 71.082031 334.40625 68.707031 332.457031 C 66.335938 330.511719 64.011719 328.503906 61.734375 326.445312 C 59.460938 324.382812 57.238281 322.265625 55.066406 320.097656 C 52.898438 317.925781 50.78125 315.703125 48.71875 313.429688 C 46.65625 311.152344 44.652344 308.828125 42.707031 306.457031 C 40.757812 304.082031 38.871094 301.664062 37.042969 299.199219 C 35.210938 296.734375 33.445312 294.222656 31.738281 291.671875 C 30.035156 289.117188 28.390625 286.527344 26.8125 283.890625 C 25.234375 281.257812 23.722656 278.589844 22.277344 275.882812 C 20.828125 273.175781 19.449219 270.433594 18.136719 267.65625 C 16.824219 264.882812 15.582031 262.078125 14.40625 259.242188 C 13.230469 256.40625 12.125 253.542969 11.09375 250.652344 C 10.058594 247.761719 9.09375 244.847656 8.203125 241.910156 C 7.3125 238.972656 6.496094 236.015625 5.75 233.035156 C 5.003906 230.058594 4.332031 227.0625 3.730469 224.054688 C 3.132812 221.042969 2.609375 218.019531 2.15625 214.980469 C 1.707031 211.945312 1.332031 208.898438 1.03125 205.84375 C 0.730469 202.789062 0.503906 199.730469 0.351562 196.664062 C 0.203125 193.597656 0.128906 190.527344 0.128906 187.457031 C 0.128906 184.390625 0.203125 181.320312 0.351562 178.253906 C 0.503906 175.1875 0.730469 172.128906 1.03125 169.074219 C 1.332031 166.019531 1.707031 162.972656 2.15625 159.933594 C 2.609375 156.898438 3.132812 153.875 3.730469 150.863281 C 4.332031 147.851562 5.003906 144.859375 5.75 141.878906 C 6.496094 138.902344 7.3125 135.945312 8.203125 133.007812 C 9.09375 130.070312 10.058594 127.15625 11.09375 124.265625 C 12.125 121.375 13.230469 118.511719 14.40625 115.675781 C 15.582031 112.839844 16.824219 110.03125 18.136719 107.257812 C 19.449219 104.484375 20.828125 101.742188 22.277344 99.035156 C 23.722656 96.328125 25.234375 93.65625 26.8125 91.023438 C 28.390625 88.390625 30.035156 85.796875 31.738281 83.246094 C 33.445312 80.691406 35.210938 78.183594 37.042969 75.71875 C 38.871094 73.253906 40.757812 70.832031 42.707031 68.460938 C 44.652344 66.085938 46.65625 63.761719 48.71875 61.488281 C 50.78125 59.214844 52.898438 56.992188 55.066406 54.820312 C 57.238281 52.648438 59.460938 50.535156 61.734375 48.472656 C 64.011719 46.410156 66.335938 44.40625 68.707031 42.457031 C 71.082031 40.511719 73.5 38.621094 75.964844 36.792969 C 78.429688 34.964844 80.941406 33.199219 83.492188 31.492188 C 86.046875 29.789062 88.636719 28.144531 91.269531 26.566406 C 93.902344 24.988281 96.574219 23.476562 99.28125 22.03125 C 101.988281 20.582031 104.730469 19.203125 107.503906 17.890625 C 110.28125 16.578125 113.085938 15.332031 115.921875 14.160156 C 118.757812 12.984375 121.621094 11.878906 124.511719 10.847656 C 127.402344 9.8125 130.316406 8.847656 133.253906 7.957031 C 136.191406 7.066406 139.148438 6.25 142.128906 5.503906 C 145.105469 4.757812 148.101562 4.082031 151.109375 3.484375 C 154.121094 2.886719 157.144531 2.363281 160.183594 1.910156 C 163.21875 1.460938 166.265625 1.085938 169.320312 0.785156 C 172.375 0.484375 175.433594 0.257812 178.5 0.105469 C 181.566406 -0.0429688 184.636719 -0.121094 187.707031 -0.121094 C 190.773438 -0.121094 193.84375 -0.0429688 196.910156 0.105469 C 199.976562 0.257812 203.035156 0.484375 206.089844 0.785156 C 209.144531 1.085938 212.191406 1.460938 215.230469 1.910156 C 218.265625 2.363281 221.289062 2.886719 224.300781 3.484375 C 227.3125 4.082031 230.304688 4.757812 233.28125 5.503906 C 236.261719 6.25 239.21875 7.066406 242.15625 7.957031 C 245.09375 8.847656 248.007812 9.8125 250.898438 10.84375 C 253.789062 11.878906 256.652344 12.984375 259.488281 14.160156 C 262.324219 15.332031 265.128906 16.578125 267.90625 17.890625 C 270.679688 19.203125 273.421875 20.582031 276.128906 22.03125 C 278.835938 23.476562 281.507812 24.988281 284.140625 26.566406 C 286.773438 28.144531 289.367188 29.785156 291.917969 31.492188 C 294.46875 33.199219 296.980469 34.964844 299.445312 36.792969 C 301.910156 38.621094 304.332031 40.511719 306.703125 42.457031 C 309.078125 44.40625 311.398438 46.410156 313.675781 48.472656 C 315.949219 50.535156 318.171875 52.648438 320.34375 54.820312 C 322.515625 56.992188 324.628906 59.214844 326.691406 61.488281 C 328.753906 63.761719 330.757812 66.085938 332.707031 68.460938 C 334.652344 70.832031 336.539062 73.253906 338.371094 75.71875 C 340.199219 78.183594 341.964844 80.691406 343.671875 83.246094 C 345.375 85.796875 347.019531 88.390625 348.597656 91.023438 C 350.175781 93.65625 351.6875 96.328125 353.132812 99.035156 C 354.582031 101.742188 355.960938 104.484375 357.273438 107.257812 C 358.585938 110.03125 359.828125 112.839844 361.003906 115.675781 C 362.179688 118.511719 363.285156 121.375 364.316406 124.265625 C 365.351562 127.15625 366.316406 130.070312 367.207031 133.007812 C 368.097656 135.945312 368.914062 138.902344 369.660156 141.878906 C 370.40625 144.859375 371.082031 147.851562 371.679688 150.863281 C 372.277344 153.875 372.800781 156.898438 373.253906 159.9375 C 373.703125 162.972656 374.078125 166.019531 374.378906 169.074219 C 374.679688 172.128906 374.90625 175.1875 375.058594 178.253906 C 375.207031 181.320312 375.285156 184.390625 375.285156 187.457031 Z M 375.285156 187.457031 " fill-opacity="1" fill-rule="nonzero" /><path fill="#ffffff" d="M 97.035156 112.332031 C 93.417969 112.332031 90.503906 115.246094 90.503906 118.863281 L 90.503906 239.667969 C 90.503906 243.285156 93.417969 246.199219 97.035156 246.199219 L 213.667969 246.199219 L 212.996094 249.042969 L 212.238281 252.210938 L 211.492188 255.386719 L 210.742188 258.5625 L 209.984375 261.730469 L 209.234375 264.90625 L 208.484375 268.074219 L 207.730469 271.246094 L 206.980469 274.421875 L 206.230469 277.589844 L 205.472656 280.765625 L 204.722656 283.941406 C 202.90625 291.601562 207.851562 286.769531 212.050781 283.941406 L 220.878906 277.589844 L 225.292969 274.421875 L 229.710938 271.246094 L 234.125 268.074219 L 238.539062 264.90625 L 242.949219 261.730469 L 247.371094 258.5625 L 256.199219 252.210938 L 260.609375 249.042969 L 264.566406 246.199219 L 278.375 246.199219 C 281.992188 246.199219 284.90625 243.285156 284.90625 239.667969 L 284.90625 118.863281 C 284.90625 115.246094 281.992188 112.332031 278.375 112.332031 L 97.03125 112.332031 Z M 97.035156 112.332031 " fill-opacity="1" fill-rule="nonzero" />
                                                                                <path fill="#545454" className=" hover:fill-[#FFB000]" d="M 121.273438 132.539062 L 254.136719 132.539062 C 254.550781 132.539062 254.949219 132.617188 255.332031 132.777344 C 255.714844 132.933594 256.050781 133.160156 256.34375 133.453125 C 256.636719 133.746094 256.863281 134.082031 257.019531 134.464844 C 257.179688 134.847656 257.257812 135.246094 257.257812 135.660156 L 257.257812 143.097656 C 257.257812 143.507812 257.179688 143.90625 257.019531 144.289062 C 256.863281 144.671875 256.636719 145.011719 256.34375 145.304688 C 256.050781 145.59375 255.714844 145.820312 255.332031 145.980469 C 254.949219 146.136719 254.550781 146.21875 254.136719 146.21875 L 121.273438 146.21875 C 120.859375 146.21875 120.460938 146.136719 120.078125 145.980469 C 119.695312 145.820312 119.359375 145.59375 119.066406 145.304688 C 118.773438 145.011719 118.546875 144.671875 118.390625 144.289062 C 118.230469 143.90625 118.152344 143.507812 118.152344 143.097656 L 118.152344 135.660156 C 118.152344 135.246094 118.230469 134.847656 118.390625 134.464844 C 118.546875 134.082031 118.773438 133.746094 119.066406 133.453125 C 119.359375 133.160156 119.695312 132.9375 120.078125 132.777344 C 120.460938 132.617188 120.859375 132.539062 121.273438 132.539062 Z M 121.273438 132.539062 " fill-opacity="1" fill-rule="nonzero" />
                                                                                <path fill="#545454" className=" hover:fill-[#FFB000]" d="M 121.273438 160.46875 L 254.136719 160.46875 C 254.550781 160.46875 254.949219 160.546875 255.332031 160.707031 C 255.714844 160.867188 256.050781 161.089844 256.34375 161.382812 C 256.636719 161.675781 256.863281 162.015625 257.019531 162.394531 C 257.179688 162.777344 257.257812 163.175781 257.257812 163.589844 L 257.257812 171.027344 C 257.257812 171.441406 257.179688 171.835938 257.019531 172.21875 C 256.863281 172.601562 256.636719 172.941406 256.34375 173.234375 C 256.050781 173.523438 255.714844 173.75 255.332031 173.910156 C 254.949219 174.066406 254.550781 174.148438 254.136719 174.148438 L 121.273438 174.148438 C 120.859375 174.148438 120.460938 174.066406 120.078125 173.910156 C 119.695312 173.75 119.359375 173.523438 119.066406 173.234375 C 118.773438 172.941406 118.546875 172.601562 118.390625 172.21875 C 118.230469 171.835938 118.152344 171.441406 118.152344 171.027344 L 118.152344 163.589844 C 118.152344 163.175781 118.230469 162.777344 118.390625 162.394531 C 118.546875 162.015625 118.773438 161.675781 119.066406 161.382812 C 119.359375 161.089844 119.695312 160.867188 120.078125 160.707031 C 120.460938 160.546875 120.859375 160.46875 121.273438 160.46875 Z M 121.273438 160.46875 " fill-opacity="1" fill-rule="nonzero" />
                                                                                <path fill="#545454" className=" hover:fill-[#FFB000]" d="M 121.273438 188.398438 L 254.136719 188.398438 C 254.550781 188.398438 254.949219 188.480469 255.332031 188.636719 C 255.714844 188.796875 256.050781 189.019531 256.34375 189.3125 C 256.636719 189.605469 256.863281 189.945312 257.019531 190.324219 C 257.179688 190.707031 257.257812 191.105469 257.257812 191.519531 L 257.257812 198.957031 C 257.257812 199.367188 257.179688 199.765625 257.019531 200.148438 C 256.863281 200.53125 256.636719 200.871094 256.34375 201.164062 C 256.050781 201.457031 255.714844 201.679688 255.332031 201.839844 C 254.949219 201.996094 254.550781 202.078125 254.136719 202.078125 L 121.273438 202.078125 C 120.859375 202.078125 120.460938 201.996094 120.078125 201.839844 C 119.695312 201.679688 119.359375 201.457031 119.066406 201.164062 C 118.773438 200.871094 118.546875 200.53125 118.390625 200.148438 C 118.230469 199.765625 118.152344 199.367188 118.152344 198.957031 L 118.152344 191.519531 C 118.152344 191.105469 118.230469 190.707031 118.390625 190.324219 C 118.546875 189.945312 118.773438 189.605469 119.066406 189.3125 C 119.359375 189.019531 119.695312 188.796875 120.078125 188.636719 C 120.460938 188.480469 120.859375 188.398438 121.273438 188.398438 Z M 121.273438 188.398438 " fill-opacity="1" fill-rule="nonzero" /></svg>

                                                                        </button>

                                                                        <span className="text-gray-700 cursor-pointer hover:underline hover:text-black transition  sm:ml-[4px]" onClick={() => toggleCommentBox(post.id)}>{postComments[post.id]?.comments?.length || post.comments} Comments</span>

                                                                    </div>
                                                                </div>

                                                                <div className="items-center">
                                                                    {Array.isArray(post.tags) &&
                                                                        post.tags.filter(tag => tag && tag !== "null" && tag !== "undefined" && tag.trim() !== "").length > 0 && (
                                                                            <span className="text-gray-700">
                                                                                {post.tags
                                                                                    .filter(tag => tag && tag !== "null" && tag !== "undefined" && tag.trim() !== "")
                                                                                    .map(tag => `#${tag}`)
                                                                                    .join(' ')}
                                                                            </span>
                                                                        )}
                                                                </div>
                                                            </div>

                                                            {/* Comment Section */}

                                                            <div className="mt-3">
                                                                {postComments[post.id]?.showCommentBox && (
                                                                    <>
                                                                        {post.user_id != userData?.user_id && (

                                                                            <div className="flex items-center mb-2">
                                                                                <img
                                                                                crossorigin="anonymous"
                                                                                    src={userData?.profile_image || IMAGE_PATHS.USER}
                                                                                    className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300 mr-3"
                                                                                    alt="User Avatar"
                                                                                />

                                                                                <div className="relative flex-1 border !border-black rounded-lg p-2 custom-focus-shadow">
                                                                                    <textarea
                                                                                        className="w-full border-none rounded-lg p-2 text-sm focus:outline-none"
                                                                                        placeholder="Write a comment..."
                                                                                        rows="2"
                                                                                        style={{ resize: "none" }}
                                                                                        maxLength={1000} // Prevents typing beyond 1000 characters
                                                                                        value={postComments[post.id]?.commentText || ""}
                                                                                        onChange={(e) => {
                                                                                            if (e.target.value.length <= 1000) {
                                                                                                handleCommentChange(post.id, e.target.value);
                                                                                            }
                                                                                        }}
                                                                                    ></textarea>

                                                                                    {/* Validation Message (If character limit reaches 1000) */}
                                                                                    {postComments[post.id]?.commentText?.length >= 1000 && (
                                                                                        <p className="text-red-500 text-xs mt-1">Maximum 1000 characters allowed.</p>
                                                                                    )}

                                                                                    {/* Post Comment Button (Only shown when text is within limit) */}
                                                                                    {postComments[post.id]?.commentText?.length > 0 && postComments[post.id]?.commentText?.length <= 1000 && (
                                                                                        <div className="absolute bottom-2 right-2">
                                                                                            <button
                                                                                                className="btn-explore-yellow"
                                                                                                onClick={() => handlePostComment(post.id)}
                                                                                            >
                                                                                                Post Comment
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/* Display Comments */}
                                                                        <div className="mt-3 pl-4 space-y-2">
                                                                            {postComments[post.id]?.comments?.slice(0, commentsToShow).map((comment) => (
                                                                                <div key={comment.id} className="p-2  rounded-md ">
                                                                                    <div className="flex items-center justify-between mb-1">
                                                                                        <div className="flex items-center mb-1">
                                                                                            <img
                                                                                            crossorigin="anonymous"
                                                                                                src={DOMAIN_URL + comment.profileImg}
                                                                                                className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300 mr-2"
                                                                                                alt="Commenter"
                                                                                            />
                                                                                            <div className="flex flex-col">
                                                                                                <p className="text-sm font-bold text-black leading-[1.2]">{comment.username}</p>
                                                                                                {
                                                                                                    comment.profile_title != null && (<p className="text-xs text-gray-500">{comment.profile_title.length > 50 ? `${comment.profile_title.substring(0, 50)}... ` : comment.profile_title}</p>)
                                                                                                }

                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Three-Dot Menu Inside Comment Header */}
                                                                                        <div className="relative flex items-center" ref={(el) => (menuRefs.current[comment.id] = el)}>
                                                                                            <p className="text-xs text-gray-500 sm:w-max md:w-max">{formatDate(new Date(comment.time))}</p>
                                                                                            <button
                                                                                                className="rond-cls relative inline-block ml-1"
                                                                                                onClick={() => toggleMenu(comment.id)}
                                                                                            >
                                                                                                <i className="fas fa-ellipsis-h cursor-pointer text-gray-700 hover:text-black  pl-[1px]"></i>
                                                                                            </button>
                                                                                            {menuOpen === comment.id && (
                                                                                                <div className="absolute right-[34px] top-0 w-max bg-white  rounded-lg shadow-lg z-10">
                                                                                                    {comment.user_id != userData?.user_id && (
                                                                                                        <div className="relative inline-block">
                                                                                                            {/* Tooltip Box */}
                                                                                                            <div className="absolute w-max top-3  transform -translate-x-1/2 bg-white border border-gray-300 rounded-md shadow-md px-4 py-1">
                                                                                                                {/* Triangle Pointer */}
                                                                                                                <div className="absolute -top-2 right-2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></div>
                                                                                                                <button className="w-full text-center text-sm font-medium text-gray-700  transition-all duration-200 rounded-md" onClick={(event) => {
                                                                                                                    event.stopPropagation();
                                                                                                                    setSelectedValue({ comment_id: comment.id, streak_id: post.id });
                                                                                                                    setPopupAction("reportcomment");
                                                                                                                    setShowPopup(true);
                                                                                                                }}>
                                                                                                                    {/* <i className="fas fa-flag mr-2 text-red-500"></i> */}
                                                                                                                    Report </button>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                    {comment.user_id == userData?.user_id && (
                                                                                                        <div className="relative inline-block">
                                                                                                            <div className="absolute w-max top-3  transform -translate-x-1/2 bg-white border border-gray-300 rounded-md shadow-md px-4 py-1">

                                                                                                                <div className="absolute -top-2 right-2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></div>
                                                                                                                <button className="w-full text-center text-sm font-medium text-gray-700  transition-all duration-200 rounded-md"
                                                                                                                    onClick={(event) => {
                                                                                                                        event.stopPropagation();
                                                                                                                        setSelectedValue({ comment_id: comment.id, streak_id: post.id });
                                                                                                                        setPopupAction("deletecomment");
                                                                                                                        setShowPopup(true);
                                                                                                                    }}>
                                                                                                                    {/* <i className="fas fa-trash mr-2 text-red-500"></i> */}
                                                                                                                    Delete
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>

                                                                                    </div>
                                                                                    <p className="text-gray-800 text-sm pl-[47px]">{comment.text}</p>
                                                                                    {/* Like & Reply */}
                                                                                    {/* <div className="flex items-center text-sm mt-1"> */}
                                                                                    {/* <div className="flex items-center cursor-pointer px-3 py-1" onClick={() => handleLikeComment(post.id, comment.id)} >
                                                                                <i className={`mr-1 text-lg fas fa-thumbs-up uptm ${comment.upvoted ? "text-blue-500" : "text-gray-500"}`}></i>
                                                                                <span className="text-gray-700 cursor-pointer hover:text-blue-500 hover:underline " onClick={() => openVoteModal(post, "upvote")}>{comment.upvotes}</span>
                                                                            </div> */}

                                                                                    <span
                                                                                        className="ml-[47px]  text-gray-700 cursor-pointer hover:underline hover:text-black transition text-[13px]"
                                                                                        onClick={() => toggleReplyBox(post.id, comment.id)}
                                                                                    >
                                                                                        Reply
                                                                                    </span>
                                                                                    <span className="text-sm">{comment.replies.length > 0 && `· ${comment.replies.length} Repl${comment.replies.length > 1 ? 'ies' : 'y'}`}</span>

                                                                                    {/* </div> */}
                                                                                    {comment.replies.length > 0 && (
                                                                                        <div className="relative ml-6 mt-4 mb-2 pl-4">
                                                                                            {/* Left-side vertical line */}
                                                                                            <div className="absolute top-0 left-0 w-0.5 bg-gray-300 h-full"></div>

                                                                                            {/* Render only first 2 replies initially */}
                                                                                            {comment.replies.slice(0, comment.showAllReplies ? comment.replies.length : 0).map((reply) => (
                                                                                                <div key={reply.id} className="relative pl-4 pb-2">
                                                                                                    <div className="flex items-center justify-between mb-1">
                                                                                                        <div className="flex items-center mb-1">
                                                                                                            <img
                                                                                                            crossorigin="anonymous"
                                                                                                                src={DOMAIN_URL + reply.profileImg}
                                                                                                                className="w-[30px] h-[30px] rounded-full object-cover border border-gray-300 mr-2"
                                                                                                                alt="Reply Avatar"
                                                                                                            />
                                                                                                            <div className="flex flex-col">
                                                                                                                <p className="text-sm font-bold leading-[1.2] text-black">{reply.username}</p>
                                                                                                                <p className="text-xs text-gray-500">{post.location}</p>
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        {/* Right-aligned time & menu */}
                                                                                                        <div className="relative flex items-center ml-auto" ref={(el) => (menuRefs.current[reply.id] = el)}>
                                                                                                            <p className="text-xs text-gray-500">{formatDate(new Date(reply.time))}</p>
                                                                                                            <button
                                                                                                                className="rond-cls relative inline-block ml-1"
                                                                                                                onClick={() => toggleMenu(reply.id)}
                                                                                                            >
                                                                                                                <i className="fas fa-ellipsis-h cursor-pointer text-gray-700 hover:text-black  pl-[1px]"></i>
                                                                                                            </button>
                                                                                                            {menuOpen === reply.id && (
                                                                                                                <div className="absolute right-[34px] top-0 w-max bg-white  rounded-lg shadow-lg z-10">
                                                                                                                    {reply.user_id != userData?.user_id && (
                                                                                                                        <div className="relative inline-block">
                                                                                                                            <div className="absolute w-max top-3  transform -translate-x-1/2 bg-white border border-gray-300 rounded-md shadow-md px-4 py-1">
                                                                                                                                <div className="absolute -top-2 right-2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></div>
                                                                                                                                <button className="w-full text-center text-sm font-medium text-gray-700  transition-all duration-200 rounded-md0" onClick={(event) => {
                                                                                                                                    event.stopPropagation();
                                                                                                                                    setSelectedValue({ commentId: comment.id, replyId: reply.id, streakId: post.id });
                                                                                                                                    setPopupAction("reportreply");
                                                                                                                                    setShowPopup(true);
                                                                                                                                }}>
                                                                                                                                    {/* <i className="fas fa-flag mr-2 text-red-500"></i>  */}
                                                                                                                                    Report
                                                                                                                                </button>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                    {reply.user_id == userData?.user_id && (
                                                                                                                        <div className="relative inline-block">
                                                                                                                            <div className="absolute w-max top-3  transform -translate-x-1/2 bg-white border border-gray-300 rounded-md shadow-md px-4 py-1">
                                                                                                                                <div className="absolute -top-2 right-2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></div>
                                                                                                                                <button className="w-full text-center text-sm font-medium text-gray-700  transition-all duration-200 rounded-md" onClick={(event) => {
                                                                                                                                    event.stopPropagation();
                                                                                                                                    setSelectedValue({ commentId: comment.id, replyId: reply.id, streakId: post.id });
                                                                                                                                    setPopupAction("deletereply");
                                                                                                                                    setShowPopup(true);
                                                                                                                                }}>
                                                                                                                                    {/* <i className="fas fa-trash mr-2 text-red-500"></i> */}
                                                                                                                                    Delete
                                                                                                                                </button>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    {/* Reply Text */}
                                                                                                    <p className="text-gray-800 text-sm pl-[37px]">{reply.text}</p>
                                                                                                </div>

                                                                                            ))}

                                                                                            {/* "See more replies" or "Collapse replies" button */}
                                                                                            {comment.replies.length > 0 && (
                                                                                                <button
                                                                                                    className="text-black font-medium text-sm cursor-pointer hover:bg-gray-200 px-2 py-1 rounded relative flex items-center  rounded-md"
                                                                                                    onClick={() => toggleReplies(post.id, comment.id)}
                                                                                                >
                                                                                                    {comment.showAllReplies ? "Collapse replies" : `See ${comment.replies.length} more replies`}
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    )}





                                                                                    {/* Reply Box */}
                                                                                    {comment.showReplyBox && (
                                                                                        <div className="flex items-start   w-full ">
                                                                                            <img
                                                                                            crossorigin="anonymous"
                                                                                                src={userData?.profile_image || IMAGE_PATHS.USER}
                                                                                                className="w-[35px] h-[35px] rounded-full object-cover border border-gray-300 mr-2"
                                                                                                alt="Commenter"
                                                                                            />


                                                                                            {/* Input Section */}
                                                                                            <div className={`flex-1 bg-white rounded-lg p-2 transition-all duration-200 ${focusedReply === comment.id
                                                                                                ? "fomc-clsr"
                                                                                                : "border border-black"
                                                                                                }`}
                                                                                            >
                                                                                                <textarea
                                                                                                    className="w-full border-none rounded-lg p-2 text-sm focus:outline-none focus:ring-0"
                                                                                                    placeholder="Write a reply..."
                                                                                                    rows="1"
                                                                                                    maxLength={1000} // Prevent typing beyond 1000 characters
                                                                                                    value={comment.replyText || ""}
                                                                                                    style={{ resize: "none" }}
                                                                                                    onChange={(e) => {
                                                                                                        if (e.target.value.length <= 1000) {
                                                                                                            handleReplyChange(post.id, comment.id, e.target.value);
                                                                                                        }
                                                                                                    }}
                                                                                                    onFocus={() => setFocusedReply(comment.id)}
                                                                                                    onBlur={() => setFocusedReply(null)}
                                                                                                ></textarea>

                                                                                                {comment.replyText?.length >= 1000 && (
                                                                                                    <p className="text-red-500 text-xs mt-1">Maximum 1000 characters allowed.</p>
                                                                                                )}

                                                                                                {/* Action Icons & Reply Button */}
                                                                                                <div className="flex items-center justify-end py-0 pr-[2px] pl-[7px]">
                                                                                                    <button
                                                                                                        className={`btn-explore-yellow ${!comment.replyText?.trim() ? "bg-gray-300 text-gray-500 cursor-not-allowed" : ""}`}
                                                                                                        onClick={() => handleReplySubmit(post.id, comment.id, comment.replyText?.trim())}
                                                                                                        disabled={!comment.replyText?.trim()} // Disable when empty
                                                                                                    >
                                                                                                        Reply
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>

                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                            ))}
                                                                            {postComments[post.id]?.comments?.length > commentsToShow && (
                                                                                <div className="text-start">
                                                                                    <button
                                                                                        className="text-black font-bold text-sm cursor-pointer  hover:bg-gray-200 px-2 py-1 rounded"
                                                                                        onClick={() => setCommentsToShow((prev) => prev + 5)}
                                                                                    >
                                                                                        Load more comments
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>

                                                        </div>



                                                    </div>
                                                ))

                                            ) : (
                                                <p>No posts available for this month.</p>
                                            )
                                    ) : (
                                        <p>Select a year and month to view posts.</p>
                                    )}
                                    {/* {currentPage < totalPages && (
                                        <div className="text-center mt-4">
                                            {isLoadingMore ? (
                                                <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50">
                                                    <Loader />
                                                </div>
                                            ) : (
                                                <button
                                                    className="text-black text-center w-full py-2 cursor-pointer hover:underline hover:text-black transition !pt-[40px]"
                                                    onClick={loadMorePosts}
                                                >
                                                    Load More Post
                                                </button>
                                            )}
                                        </div>
                                    )} */}
                                    {currentPage < totalPages && (
                                        <div
                                            ref={loaderRef}
                                            className="h-10"
                                            aria-hidden="true"
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Container>
                        {showPopup && selectedValue && (
                            <ConfirmationPopup
                                isOpen={showPopup}
                                title={
                                    popupAction === "deletecomment"
                                        ? "Delete This Entry?"
                                        : popupAction === "reportcomment"
                                            ? "Report Comment"
                                            : popupAction === "deletereply"
                                                ? "Delete This Entry?"
                                                : popupAction === "reportreply"
                                                    ? "Report Reply"
                                                    : popupAction === "deletepost"
                                                        ? "Delete This Entry?"
                                                        : "Report Post"
                                }
                                message={
                                    popupAction === "deletecomment"
                                        ? "This will permanently delete the record. This action cannot be undone."
                                        : popupAction === "reportcomment"
                                            ? "Are you sure you want to report this comment? Our team will review your report and take appropriate action."
                                            : popupAction === "deletereply"
                                                ? "This will permanently delete the record. This action cannot be undone."
                                                : popupAction === "reportreply"
                                                    ? "Are you sure you want to report this reply? Our team will review your report and take appropriate action.."
                                                    : popupAction === "deletepost"
                                                        ? "This will permanently delete the record. This action cannot be undone."
                                                        : "Are you sure you want to report this post? Our team will review your report and take appropriate action."
                                }
                                onClose={() => setShowPopup(false)} // ✅ Close on cancel
                                onConfirm={async () => {
                                    if (popupAction === "deletecomment") {
                                        await deleteComment(selectedValue);
                                        window.location.reload();
                                    } else if (popupAction === "reportcomment") {
                                        await reportComment(selectedValue);
                                    } else if (popupAction === "deletereply") {
                                        await deleteReply(selectedValue);
                                        window.location.reload();
                                    } else if (popupAction === "reportreply") {
                                        await reportReply(selectedValue);
                                    } else if (popupAction === "deletepost") {
                                        await deletePost(selectedValue);
                                        window.location.reload();
                                    } else if (popupAction === "reportpost") {
                                        await reportPost(selectedValue);
                                    }
                                }}
                                loading={false}
                                showCancelButton={true}
                                actionType={
                                    popupAction?.startsWith("delete") ? "delete" : "report"
                                }
                            />
                        )}
                    </section>
                    {showWelcomeModal && (
                        <WelcomeModal
                            show={showWelcomeModal}
                            handleClose={handleCloseWelcome}
                        />
                    )}
                    <VoteModal selectedVotes={selectedVotes} closeVoteModal={closeVoteModal} />
                    <PostModal show={showModal} handleClose={() => setShowModal(false)} handlePost={handlePostModal} userData={userData} />

                    <FooterStyle theme="light" className="bg-black text-[#828282]" />
                </>
            )}
        </div>
    );

};

export default Feed;
